import React, { useState, useEffect, useContext } from "react";
import { GlobalContext } from "../../../context/globalContext";
import { ListSelectorMultiple } from "../../_molecules/_list-selector/ListSelectorMultiple";
import { NavShopping } from "../../_molecules/_nav-shopping/NavShopping";
import { Alert } from "../../_molecules/_alert/Alert";
import { BtnSimple } from "../../_atoms/_btn-simple/BtnSimple";
import { LinkSimple } from "../../_atoms/_link-simple/LinkSimple";
import { sendAnalytics } from "../../../utils/analytics";

//import { ThankYou } from "../../_molecules/_thankyou/ThankYou";

export const ClosedPricesContent = ({ bsiData, data, contractedBSI }) => {
  //TODO Turn this into a hook
  const { state: stateGlobal } = useContext(GlobalContext);
  const { brand, carSpecs, outlet, outletName, provinceValue, inputValue } = stateGlobal;
  const content = require(`../../../data/${brand}-lang.es.json`);
  const external_links = content.external_links;
  //Añadimos campos que no vienen del WS

  //console.log(data);

  //Calculamos la antiguedad del coche
  const { firstRegistrationDate, carousel } = carSpecs;

  //convertimos la fecha a formato inglés.
  const temp = firstRegistrationDate.split(".");
  let firstRegistrationDateUS = temp[1] + "/" + temp[0] + "/" + temp[2];

  // //la fecha de hoy...
  let todayDate = new Date();
  const dd = String(todayDate.getDate()).padStart(2, "0");
  const mm = String(todayDate.getMonth() + 1).padStart(2, "0"); //January is 0!
  const yyyy = todayDate.getFullYear();
  todayDate = new Date(yyyy, mm - 1, dd);

  firstRegistrationDateUS = new Date(firstRegistrationDateUS);

  // To calculate the time difference of two dates
  let antiquity = todayDate.getTime() - firstRegistrationDateUS.getTime();
  let moreThan24;
  // To calculate the no. of days between two dates
  antiquity = Math.floor(antiquity / (1000 * 3600 * 24 * 365));

  antiquity > 2 ? (moreThan24 = true) : (moreThan24 = false);

  // console.log({ moreThan24 });
  // console.log({ antiquity });
  const newProductsArray = data.map((item) => {
    return { ...item, visible: true, active: false };
  });

  //Paso a la thank U page
  const goToStep = (num) => {
    console.log("Changing step to:", num);
    setState({ ...state, step: num });

    if (num === 1) {
      const shoppingCartGTM = shoppingCart.map((item, i) => {
        return item.id_ws;
      });

      let shoppingCartGTMObject = {};
      shoppingCart.forEach((item) => {
        shoppingCartGTMObject[item.nombre] = item.id_ws;
      });

      //GTM
      window.dataLayer.push({
        event: "sc_seleccion_servicios",
        modelo: carSpecs.ecode,
        provincia: provinceValue,
        taller: outletName,
        buno: outlet,
        servicios: shoppingCartGTM,
        shoppingCartGTMObject,
      });
    }
  };
  const appointmentGTM = () => {
    //GTM
    window.dataLayer.push({
      event: "sc_pedir_cita",
      modelo: carSpecs.ecode,
      provincia: provinceValue,
      taller: outletName,
      buno: outlet,
    });
  };
  const [state, setState] = useState({
    shoppingCart: [],
    step: 0,
    products: newProductsArray,
    aditional: false,
    total: 0,
    kmSelectorYears: 2,
    kmSelectorKM: "30.000",
    recommendedProducts: [],
  });
  const { shoppingCart, products, aditional, total, step } = state;

  //Eliminamos el aditional y hacemos calculos en la cesta cuando se actualice
  useEffect(() => {
    const hasAdditional = shoppingCart.some((item) => {
      if (item.aditional) {
        return true;
      } else {
        return false;
      }
    });

    let aditionalValue = shoppingCart.find((item) => {
      if (item.aditional) {
        return true;
      } else {
        return false;
      }
    });

    aditionalValue ? (aditionalValue = aditionalValue.aditional) : (aditionalValue = false);

    //Si no quedan aditional, los eliminamos, si hay aun..lo ignoramos
    let totalValue = 0;

    if (aditionalValue.price !== undefined) {
      if (hasAdditional) {
        totalValue = (total + parseFloat(aditionalValue.price)).toFixed(2);
      } else {
        totalValue = (total - parseFloat(aditionalValue.price)).toFixed(2);
      }
    } else {
      totalValue = total.toFixed(2);
    }

    setState({
      ...state,
      aditional: aditionalValue,
      total: totalValue,
    });
  }, [shoppingCart]);

  const createPDF = (e) => {
    //console.log("imprimir PDF");
    //GTM
    window.dataLayer.push({
      event: "sc_imprimir",
    });

    let pdfProducts = shoppingCart.map((item) => {
      return {
        nombre: item.nombre,
        valor: item.valor,
        descripcion: item.descripcion,
        ispreciodesde: "0",
      };
    });

    pdfProducts.push({
      nombre: aditional.name,
      valor: aditional.price,
      descripcion: aditional.description,
      ispreciodesde: "0",
    });

    //   console.log(pdfAditional);

    const post = {
      importe_total: total,
      fecha_caducidad_precio: "31/12/2025.",
      acabado: "",
      serie: carSpecs.brandBame,
      modelo: carSpecs.ecode,
      nombre_imagen: carSpecs.ecode,
      nombre_outlet: outletName,
      direccion_outlet: provinceValue,
      matricula: inputValue,
      numero_bastidor: carSpecs.longVin,
      numero_servicios: pdfProducts.length,
      servicios: pdfProducts,
    };

    const url = `https://api.${brand}.es/rest/closedprice/pdf.php`;

    fetch(url, {
      method: "POST", // or 'PUT'
      body: JSON.stringify(post), // data can be `string` or {object}!
      headers: {
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      responseType: "blob",
    })
      .then((response) => response.blob())
      .then((blob) => {
        let link = window.URL.createObjectURL(blob);
        window.open(link, "_blank");

        //  window.location = link;
      });

    //     fetch(url, {
    //       method: "POST", // or 'PUT'
    //       body: dataPDFReady, // data can be `string` or {object}!
    //       headers: {
    //         "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
    //       },
    //       responseType: "blob",
    //     }).then((response) => {
    //       var filename = "presu.pdf";
    //       var blob = new Blob([response.blob()], { type: "application/pdf" });
    //       var link = document.createElement("a");
    //       link.href = window.URL.createObjectURL(blob);
    //       link.download = filename;
    //
    //       document.body.appendChild(link);
    //
    //       link.click();
    //
    //       document.body.removeChild(link);
    //     });
    //   };
  };

  const updateCart = (e) => {
    //e.preventDefault();
    e.stopPropagation();
    const productSelectedID = parseInt(e.target.value);

    //Buscamos el producto seleccionado dentro del estado
    const productSelected = products.find((item) => {
      if (parseInt(item.idServicio) === productSelectedID) {
        return item;
      } else {
        return;
      }
    });

    //Está ya en la cesta?
    const isInShoppingCart = shoppingCart.some((item) => {
      if (parseInt(item.idServicio) === productSelectedID) {
        return true;
      } else {
        return;
      }
    });

    productSelected.active = true;

    //Calculamos el total actual en la cesta
    let shoppingCartTotal = 0;
    shoppingCart.forEach((item) => {
      let valor = parseFloat(item.valor);
      shoppingCartTotal = shoppingCartTotal + valor;
    });

    if (!isInShoppingCart) {
      //Añadimos a la cesta

      shoppingCartTotal = shoppingCartTotal + parseFloat(productSelected.valor);

      //Detección de servicios para productos excluyentes / incluyentes.
      //TO DO: pasar todo esto a un reducer
      const hasOilService = shoppingCart.some((item) => {
        return item.id_ws === "CBS_OIL_SERVICE";
      });

      const hasMicrofilter = shoppingCart.some((item) => {
        return item.id_ws === "CBS_MICROFILTER";
      });

      const isFrontBrake = productSelected.id_ws === "BRAKE_DISCS_FRONT_ASSOCIATED" ? true : false;

      const isBackBrake = productSelected.id_ws === "BRAKE_DISCS_REAR_INSTALL_ASSOCIATED" ? true : false;

      const hasFrontPad = shoppingCart.some((item) => {
        return item.id_ws === "CBS_FRONT_BRAKE_PADS";
      });

      const hasBackPad = shoppingCart.some((item) => {
        return item.id_ws === "CBS_REAR_BRAKE_PADS";
      });

      // COMENTADO PARA ELIMINAR EXCLUYENTES OIL
      //Si ya tenemos los productos de aceite en la cesta..
      // if (
      //   (hasOilService && productSelected.id_ws === "CBS_MICROFILTER") ||
      //   (hasMicrofilter && productSelected.id_ws === "CBS_OIL_SERVICE")
      // ) {
      //console.log("Producto incompatible detectado");
      //         if (productSelected.id_ws === "CBS_MICROFILTER") {
      //           //Eliminamos el servicio de aceite
      //
      //           //Producto a marcar como inactivo
      //           const productForceRemove = products.find((item) => {
      //             if (item.id_ws === "CBS_OIL_SERVICE") {
      //               return item;
      //             }
      //           });
      //           // console.log("Eliminamos CBS_OIL_SERVICE");
      //           productForceRemove.active = false;
      //
      //           let shoppingCartValue = shoppingCart.filter((item) => {
      //             return item.id_ws !== "CBS_OIL_SERVICE";
      //           });
      //
      //           shoppingCartValue = [...shoppingCartValue, productSelected];
      //
      //           shoppingCartTotal =
      //             shoppingCartTotal - parseFloat(productForceRemove.valor);
      //
      //           setState({
      //             ...state,
      //             shoppingCart: shoppingCartValue,
      //             products: [...products],
      //             total: shoppingCartTotal,
      //           });
      //         } else {
      //           //Producto a marcar como inactivo
      //           const productForceRemove = products.find((item) => {
      //             if (item.id_ws === "CBS_MICROFILTER") {
      //               return item;
      //             }
      //           });
      //           // console.log("Eliminamos CBS_MICROFILTER");
      //           productForceRemove.active = false;
      //
      //           let shoppingCartValue = shoppingCart.filter((item) => {
      //             return item.id_ws !== "CBS_MICROFILTER";
      //           });
      //
      //           shoppingCartValue = [...shoppingCartValue, productSelected];
      //
      //           shoppingCartTotal =
      //             shoppingCartTotal - parseFloat(productForceRemove.valor);
      //
      //           setState({
      //             ...state,
      //             shoppingCart: shoppingCartValue,
      //             products: [...products],
      //             total: shoppingCartTotal,
      //           });
      //         }
      //} else {
      console.log("No hay productos incompatibles, hay productos inclusivos?");
      //No hay productos excluyents, vemos si hay incluyentes, y solo los añadimos si no estan en la cesta.
      if (isFrontBrake && !hasFrontPad) {
        // console.log("Frenos delanteros, añadimos pastillas delanteras!");

        const productForceAdd = products.find((item) => {
          if (item.id_ws === "CBS_FRONT_BRAKE_PADS") {
            return item;
          }
        });
        // console.log("Eliminamos CBS_OIL_SERVICE");
        productForceAdd.active = true;

        //Creamos un valor de la cesta que incluye el contenido actual, el producto que añadimos y el que vamos a añadir.
        const shoppingCartValue = [...shoppingCart, productSelected, productForceAdd];

        shoppingCartTotal = shoppingCartTotal + parseFloat(productForceAdd.valor);

        setState({
          ...state,
          shoppingCart: shoppingCartValue,
          products: [...products],
          total: shoppingCartTotal,
        });
      } else if (isBackBrake && !hasBackPad) {
        //console.log("Frenos traseros, añadimos pastillas traseras!");
        //Mismo caso que con los frenos delanteros, lógica 100% igual
        const productForceAdd = products.find((item) => {
          if (item.id_ws === "CBS_REAR_BRAKE_PADS") {
            return item;
          }
        });
        // console.log("Eliminamos CBS_OIL_SERVICE");
        productForceAdd.active = true;

        const shoppingCartValue = [...shoppingCart, productSelected, productForceAdd];

        shoppingCartTotal = shoppingCartTotal + parseFloat(productForceAdd.valor);

        setState({
          ...state,
          shoppingCart: shoppingCartValue,
          products: [...products],
          total: shoppingCartTotal,
        });
      } else {
        //Si no hay excluyentes ni incluyentes añadimos el producto
        setState({
          ...state,
          shoppingCart: [...shoppingCart, productSelected],
          products: [...products],
          total: shoppingCartTotal,
        });
      }
      //} // COMENTADO PARA ELIMINAR EXCLUYENTES OIL
    } else {
      //Eliminamos de la cesta
      console.log("Eliminamos de la cesta");
      productSelected.active = false;
      const shoppingCartValue = shoppingCart.filter((item) => {
        return parseInt(item.idServicio) !== productSelectedID;
      });

      shoppingCartTotal = shoppingCartTotal - parseFloat(productSelected.valor);

      //Hay productos adicionales ya en la cesta?
      //Los eliminamos mediante useEffect más arriba..

      setState({
        ...state,
        shoppingCart: shoppingCartValue,
        products: [...products],
        total: shoppingCartTotal,
        step: 0,
      });
    }
  };

  return (
    <div className="container-grid closed-prices">
      <>
        {/* Aviso si menos de 24 sin importar de donde venga */}
        {!moreThan24 && (
          <Alert css="alert--info">
            <ul className="list list--icons list--icons--md">
              <li>
                <div className="text">
                  <svg className="icon">
                    <use xlinkHref="./svg/sprite.svg#form-info"></use>
                  </svg>
                  Si tu vehículo tiene una antigüedad de más de 4 años puedes contactar con tu  {" "}
                  <LinkSimple
                    href="https://www.bmw.es/es/ssl/citaprevia/encuentra-tu-concesionario.html"
                    target="_blank">
                    Taller Autorizado {brand.toUpperCase()}
                  </LinkSimple>{" "}
                  para más información. Programa solo disponible para modelos de 4 y 6 cilindros. También puedes
                  consultar los paquetes de mantenimiento BSI.
                </div>
              </li>
            </ul>
          </Alert>
        )}
        {/* Aviso si más de 24 pero viene de selector de modelos */}
        {moreThan24 && carousel && (
          <Alert css="alert--info">
            <ul className="list list--icons list--icons--md">
              <li>
                <div className="text">
                  <svg className="icon">
                    <use xlinkHref="./svg/sprite.svg#form-info"></use>
                  </svg>
                  Si tu vehículo tiene una antigüedad de más de 4 años puedes contactar con tu  {" "}
                  <LinkSimple
                    href="https://www.bmw.es/es/ssl/citaprevia/encuentra-tu-concesionario.html"
                    target="_blank">
                    Taller Autorizado {brand.toUpperCase()}
                  </LinkSimple>{" "}
                  para más información. Programa solo disponible para modelos de 4 y 6 cilindros. También puedes
                  consultar los paquetes de mantenimiento BSI.
                </div>
              </li>
            </ul>
          </Alert>
        )}
        {/* Aviso si más de 24 pero menos de 4 */}
        {moreThan24 && !data.length && (
          <Alert css="alert--info">
            <ul className="list list--icons list--icons--md">
              <li>
                <div className="text">
                  <svg className="icon">
                    <use xlinkHref="./svg/sprite.svg#form-info"></use>
                  </svg>
                  Si tu vehículo tiene una antigüedad de más de 4 años puedes contactar con tu  {" "}
                  <LinkSimple
                    href="https://www.bmw.es/es/ssl/citaprevia/encuentra-tu-concesionario.html"
                    target="_blank">
                    Taller Autorizado {brand.toUpperCase()}
                  </LinkSimple>{" "}
                  para más información. Programa solo disponible para modelos de 4 y 6 cilindros. También puedes
                  consultar los paquetes de mantenimiento BSI.
                </div>
              </li>
            </ul>
          </Alert>
        )}
        {moreThan24 && data.length > 0 && (
          <>
            <Alert css="alert--warning">
              <ul className="list list--icons list--icons--md">
                <li>
                  <div className="text">
                    <svg className="icon">
                      <use xlinkHref="./svg/sprite.svg#form-danger"></use>
                    </svg>
                    Los servicios identificados con esta leyenda incluyen un coste adicional que se facturará una sola
                    vez, independientemente del número de operaciones a realizar.
                  </div>
                </li>
              </ul>
            </Alert>
            {contractedBSI && moreThan24 && (
              <Alert css="alert--success">
                <ul className="list list--icons list--icons--md">
                  <li>
                    <div className="text">
                      <svg className="icon">
                        <use xlinkHref="./svg/sprite.svg#form-success"></use>
                      </svg>
                      Recuerda que YA TIENES CONTRATADO UN PAQUETE DE MANTENIMIENTO {brand.toUpperCase()} SERVICE
                      INCLUSIVE vigente y los servicios identificados con esta leyenda ya están incluidos en el mismo.
                    </div>
                  </li>
                </ul>
              </Alert>
            )}
            <div data-col-md={data.length > 0 && 8}>
              <div className="closed-prices-products">
                <div className="h3 services">
                  <span>servicios disponibles</span>
                </div>
                <ul>
                  {products.map((item, i) => {
                    return (
                      <li key={i}>
                        <ListSelectorMultiple
                          name={item.nombre}
                          desc={item.descripcion}
                          id={item.id_ws}
                          onChange={updateCart}
                          icon={`${item.aditional ? "form-info" : false}`}
                          price={item.valor}
                          button="Ver detalle"
                          value={item.idServicio}
                          active={item.active}
                          disabled={
                            (item.id_ws === "CBS_AIR_FILTER" && contractedBSI === "SI") ||
                            (item.id_ws === "CBS_FUEL_FILTER" && contractedBSI === "SI") ||
                            (item.id_ws === "CBS_OIL_SERVICE" && contractedBSI === "SI") ||
                            (item.id_ws === "CBS_MICROFILTER" && contractedBSI === "SI") ||
                            (item.id_ws === "CBS_BRAKE_FLUID" && contractedBSI === "SI") ||
                            (item.id_ws === "CBS_SPARK_PLUGS" && contractedBSI === "SI") ||
                            (item.id_ws === "CBS_VEHICLE_CHECK" && contractedBSI === "SI") ||
                            (item.id_ws === "STANDARD_SCOPE" && contractedBSI === "SI") ||
                            (item.id_ws === "SII_INSPECTION_1_BMW" && contractedBSI === "SI") ||
                            (item.id_ws === "SII_OIL_SERVICE_AND_MICROFILTER_BMW" && contractedBSI === "SI") ||
                            (item.id_ws === "SII_OIL_SERVICE_BMW" && contractedBSI === "SI") ||
                            (item.id_ws === "CBS_OIL_SERVICE" && contractedBSI === "SI") ||
                            (item.id_ws === "SII_OIL_SERVICE_AND_MICROFILTER_BMW" && contractedBSI === "SI") ||
                            (item.id_ws === "SII_INSPECTION_1_BMW" && contractedBSI === "SI") ||
                            (item.id_ws === "SII_INSPECTION_2_BMW" && contractedBSI === "SI") ||
                            (item.id_ws === "SII_INSPECTION_3_BMW" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_AIR_FILTER" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_FUEL_FILTER" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_OIL_SERVICE" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_FRONT_BRAKE_PADS" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_REAR_BRAKE_PADS" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_MICROFILTER" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_BRAKE_FLUID" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_SPARK_PLUGS" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_VEHICLE_CHECK" && contractedBSI === "SI+") ||
                            (item.id_ws === "STANDARD_SCOPE" && contractedBSI === "SI+") ||
                            (item.id_ws === "BRAKE_PADS_FRONT" && contractedBSI === "SI+") ||
                            (item.id_ws === "BRAKE_DISCS_FRONT_ASSOCIATED" && contractedBSI === "SI+") ||
                            (item.id_ws === "BRAKE_PADS_REAR" && contractedBSI === "SI+") ||
                            (item.id_ws === "BRAKE_DISCS_REAR_INSTALL_ASSOCIATED" && contractedBSI === "SI+") ||
                            (item.id_ws === "SII_INSPECTION_1_BMW" && contractedBSI === "SI+") ||
                            (item.id_ws === "SII_OIL_SERVICE_AND_MICROFILTER_BMW" && contractedBSI === "SI+") ||
                            (item.id_ws === "SII_OIL_SERVICE_BMW" && contractedBSI === "SI+") ||
                            (item.id_ws === "CBS_OIL_SERVICE" && contractedBSI === "SI+") ||
                            (item.id_ws === "SII_OIL_SERVICE_AND_MICROFILTER_BMW" && contractedBSI === "SI+") ||
                            (item.id_ws === "SII_INSPECTION_1_BMW" && contractedBSI === "SI+") ||
                            (item.id_ws === "SII_INSPECTION_2_BMW" && contractedBSI === "SI+") ||
                            (item.id_ws === "SII_INSPECTION_3_BMW" && contractedBSI === "SI+") ||
                            (item.id_ws === "WIPERBLADES_FRONT" && contractedBSI === "SI+")
                              ? true
                              : false
                          }
                        />
                      </li>
                    );
                  })}
                </ul>
                {total !== 0 && (
                  <div className="closed-prices-products__btn">
                    <BtnSimple
                      aria="Confirmar pedido"
                      type="button"
                      css="btn-simple--1 btn--center"
                      children="Continuar"
                      onClick={() => goToStep(1)}
                    />
                  </div>
                )}
              </div>
            </div>
            <div data-col-md="4">
              <NavShopping title="Servicios seleccionados">
                <ul className="list">
                  {shoppingCart.map((item) => {
                    return (
                      <li className="list-li" key={item.nombre}>
                        <div>{item.nombre} </div>
                        <strong>{item.valor} €</strong>
                      </li>
                    );
                  })}
                  {aditional && (
                    <>
                      <li className="list-li">
                        <div>{aditional.name}</div>
                        <strong> {aditional.price} €</strong>
                      </li>
                    </>
                  )}
                  {total !== 0 && (
                    <>
                      <li>
                        <hr className="list-hr"></hr>
                        <div className="list-total">
                          <strong>TOTAL</strong>
                          <strong>{total} €</strong>
                        </div>
                      </li>
                    </>
                  )}
                </ul>

                {total !== 0 && (
                  <div className="nav-shopping__btn">
                    {step === 0 && (
                      <BtnSimple
                        aria="Confirmar pedido"
                        type="button"
                        css="btn-simple--1 btn--center"
                        children="Continuar"
                        onClick={() => {
                          const cartContents = shoppingCart.map((item) => ({
                            name: item.nombre,
                            price: item.valor,
                          }));

                          if (aditional) {
                            cartContents.push({
                              name: aditional.name,
                              price: aditional.price,
                            });
                          }

                          sendAnalytics("Click en Continuar", {
                            total: total,
                            items: cartContents,
                          });

                          goToStep(1);
                        }}
                      />
                    )}
                    {step === 1 && (
                      <BtnSimple
                        aria="Pedir cita"
                        css="btn-simple--2 btn--center btn-dealer"
                        type="link"
                        href={`${external_links.online_shop_appointment}${outlet.split("/")[0]}`}
                        children="Cita online taller"
                        target="_blank"
                        onClick={() => {
                          sendAnalytics("Click en Cita online taller", "Pedir Cita");

                          appointmentGTM();
                        }}
                      />
                    )}
                    {step === 1 && (
                      <BtnSimple
                        aria="Imprimir pdf"
                        css="btn-simple--3 btn-pdf"
                        herf="https://bmw.es"
                        onClick={() => {
                          sendAnalytics("Click en Descargar oferta", "Descargar oferta");

                          createPDF();
                        }}
                        children={[
                          <>
                            <ul className="list list--icons list--icons--xs">
                              <li>
                                <div className="text">
                                  <svg className="icon">
                                    <use xlinkHref="./svg/sprite.svg#download"></use>
                                  </svg>
                                  Descargar oferta
                                </div>
                              </li>
                            </ul>
                          </>,
                        ]}
                      />
                    )}
                  </div>
                )}
              </NavShopping>
            </div>
          </>
        )}
        {/* Si estamos en el paso de gracias...
        {step === 1 && (
          <div data-col-md="8">

             <ThankYou onClick={() => goToStep(0)} onPrint={createPDF} title="¡GRACIAS POR CONSULTAR TUS PRECIOS!" subtitle={`Pide Cita en tu taller autorizado ${brand.toUpperCase()}`} href={`${external_links.online_shop_appointment}${outlet.split("/")[0]}`} />

            <div className="thankyou__content">
        <span className="h3">{title}</span>


        <span className="h5">{subtitle}</span>


      </div>
          </div>
        )}  */}
      </>
    </div>
  );
};
